// Table searches match case-insensitive regexes server-side (`pattern: { regex, ignoreCase: true }`),
// so typed text is escaped and split on spaces, and every word has to match.

function escapeRegex(word: string): string {
  return word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function searchWords(query: string): string[] {
  return query.trim().split(/\s+/).filter(Boolean);
}

// Lookaheads let the words appear in any order within one field.
function allWordsPattern(words: string[]): string {
  if (words.length === 1) return escapeRegex(words[0]);
  return "^" + words.map((word) => `(?=.*${escapeRegex(word)})`).join("");
}

export function fieldSearchVars(query: string): { pattern: string } {
  return { pattern: allWordsPattern(searchWords(query)) };
}

// "All Fields" queries take three word slots, each matched against any field, so words can land in
// different fields. A 4th+ word folds into the last slot, so those words have to share a field.
// Unused slots stay undefined, which drops that filter from the query.
export function allFieldsSearchVars(query: string): { w1: string; w2?: string; w3?: string } {
  const words = searchWords(query);
  const slots = words.length > 3 ? [...words.slice(0, 2).map((word) => [word]), words.slice(2)] : words.map((word) => [word]);
  const [w1, w2, w3] = slots.map(allWordsPattern);
  return { w1, w2, w3 };
}
